import { useParams } from "react-router-dom"
import EnhancementContactForm from "./EnhancementContactForm";
import { useAuthContext } from "../../../../context/AuthContext";

const ContactForm = () => {
    const params = useParams();
    const { business } = useAuthContext();
    return (
        <EnhancementContactForm business={business} id={params.id} />
    )
}
export default ContactForm;